import { apiClient } from '@/utils/api-client'
import { cleanParams } from '@/utils/clean-params'

const API_INTERNAL_BASE = '/teams'

class TeamService {
    async list() {
        return await apiClient
            .get(API_INTERNAL_BASE)
            .then((response) => response.data)
    }

    /**
     * Search teams for the current account, paginated for typeahead pickers.
     *
     * @param {Object} params - Query parameters
     * @param {string} [params.search] - Search term matched against team name
     * @param {number} [params.per_page] - Results per page (1-50, default 20)
     * @param {string} [params.cursor] - Pagination cursor
     * @returns {Promise<Object>} Response with data[], meta
     */
    async search(params = {}) {
        return await apiClient
            .get(API_INTERNAL_BASE + '/search', {
                params: cleanParams(params),
            })
            .then((response) => response.data)
    }

    async get(teamUlid) {
        return await apiClient
            .get(API_INTERNAL_BASE + '/' + teamUlid)
            .then((response) => response.data)
    }

    async create(form) {
        return await apiClient
            .post(API_INTERNAL_BASE, form)
            .then((response) => response.data)
    }

    async update(teamUlid, form) {
        return await apiClient
            .put(API_INTERNAL_BASE + '/' + teamUlid, form)
            .then((response) => response.data)
    }

    async remove(teamUlid) {
        return await apiClient
            .delete(API_INTERNAL_BASE + '/' + teamUlid)
            .then((response) => response.data)
    }

    async addUser(teamUlid, userUlid) {
        return await apiClient
            .post(
                API_INTERNAL_BASE + '/' + teamUlid + '/users/' + userUlid,
                null
            )
            .then((response) => response.data)
    }

    async removeUser(teamUlid, userUlid) {
        return await apiClient
            .delete(API_INTERNAL_BASE + '/' + teamUlid + '/users/' + userUlid)
            .then((response) => response.data)
    }

    async listGrants(teamUlid) {
        return await apiClient
            .get(API_INTERNAL_BASE + '/' + teamUlid + '/grants')
            .then((response) => response.data)
    }

    async createGrant(teamUlid, form) {
        return await apiClient
            .post(API_INTERNAL_BASE + '/' + teamUlid + '/grants', form)
            .then((response) => response.data)
    }

    async revokeGrant(teamUlid, grantUlid) {
        return await apiClient
            .delete(API_INTERNAL_BASE + '/' + teamUlid + '/grants/' + grantUlid)
            .then((response) => response.data)
    }
}

export default new TeamService()
